import * as React from "react";

function LogsSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={47.983}
      height={26.906}
      {...props}
    >
      <path
        d="M17.779 18.888a4.008 4.008 0 104 4.011 4.006 4.006 0 00-4-4.011zm0 6.014a2 2 0 112-2 2 2 0 01-2 2.002zm30.2-8.976v4.276a1.932 1.932 0 01-1.932 1.931h-2.062a5.3 5.3 0 00-10.488 0H23.021a5.3 5.3 0 00-10.482 0H9.951a1.931 1.931 0 01-1.931-1.931v-4.274zm-9.24 2.963a4.008 4.008 0 104 4.011 4.012 4.012 0 00-3.996-4.012zm0 6.014a2 2 0 112-2 2 2 0 01-1.996 2.001zm8.479-13.283l-7.591-7.507a2.58 2.58 0 00-1.809-.747h-3.827V1.93A1.929 1.929 0 0032.06-.001H9.95A1.933 1.933 0 008.019 1.93v.3l-7.838.9L14.07 4.939 0 6.344l14.02 1.993L0 9.553l8.019 1.512v3.8h39.963v-1.41a2.588 2.588 0 00-.76-1.834zm-3.309.251h-7.342a.3.3 0 01-.3-.3V5.898a.3.3 0 01.3-.3h1.4a.326.326 0 01.212.084l5.943 5.672a.3.3 0 01-.209.519z"
        fill="#ff7b16"
      />
    </svg>
  );
}

export default LogsSvg;
